import { ComponentRef, Injectable, ViewContainerRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CodeEditorComponent } from '@selfai-platform/pipeline-shared';

@Injectable()
export class CodeEditorManagerService {
  private codeEditorRef: ComponentRef<CodeEditorComponent> | undefined;

  openCodeEditor(container: ViewContainerRef, control: FormControl<string | null>): void {
    this.destroyCodeEditor();

    this.codeEditorRef = container.createComponent(CodeEditorComponent);

    this.codeEditorRef.instance.value = control.value || '';
    this.codeEditorRef.instance.canMaximized = true;

    this.codeEditorRef.instance.registerOnChange((newValue: string) => {
      control.setValue(newValue);
    });

    this.codeEditorRef.instance.maximazeEditor();
  }

  destroyCodeEditor(): void {
    if (this.codeEditorRef) {
      this.codeEditorRef.destroy();
      this.codeEditorRef = undefined;
    }
  }

  hasActiveEditor(): boolean {
    return !!this.codeEditorRef;
  }
}
